var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEditmeta = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.69332 13.0133C3.28666 13.0133 2.90666 12.8733 2.63332 12.6133C2.28666 12.2867 2.11999 11.7933 2.17999 11.26L2.42666 9.10001C2.47332 8.69334 2.71999 8.15334 3.00666 7.86001L8.47999 2.06667C9.84666 0.620007 11.2733 0.580007 12.72 1.94667C14.1667 3.31334 14.2067 4.74001 12.84 6.18667L7.36666 11.98C7.08666 12.28 6.56666 12.56 6.15999 12.6267L4.01332 12.9933C3.89999 13 3.79999 13.0133 3.69332 13.0133ZM10.62 1.94001C10.1067 1.94001 9.65999 2.26001 9.20666 2.74001L3.73332 8.54001C3.59999 8.68001 3.44666 9.01334 3.41999 9.20667L3.17332 11.3667C3.14666 11.5867 3.19999 11.7667 3.31999 11.88C3.43999 11.9933 3.61999 12.0333 3.83999 12L5.98666 11.6333C6.17999 11.6 6.49999 11.4267 6.63332 11.2867L12.1067 5.49334C12.9333 4.61334 13.2333 3.80001 12.0267 2.66667C11.4933 2.15334 11.0333 1.94001 10.62 1.94001Z",
    fill: "url(#paint0_linear_2496_36289)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69332 13.0133C3.28666 13.0133 2.90666 12.8733 2.63332 12.6133C2.28666 12.2867 2.11999 11.7933 2.17999 11.26L2.42666 9.10001C2.47332 8.69334 2.71999 8.15334 3.00666 7.86001L8.47999 2.06667C9.84666 0.620007 11.2733 0.580007 12.72 1.94667C14.1667 3.31334 14.2067 4.74001 12.84 6.18667L7.36666 11.98C7.08666 12.28 6.56666 12.56 6.15999 12.6267L4.01332 12.9933C3.89999 13 3.79999 13.0133 3.69332 13.0133ZM10.62 1.94001C10.1067 1.94001 9.65999 2.26001 9.20666 2.74001L3.73332 8.54001C3.59999 8.68001 3.44666 9.01334 3.41999 9.20667L3.17332 11.3667C3.14666 11.5867 3.19999 11.7667 3.31999 11.88C3.43999 11.9933 3.61999 12.0333 3.83999 12L5.98666 11.6333C6.17999 11.6 6.49999 11.4267 6.63332 11.2867L12.1067 5.49334C12.9333 4.61334 13.2333 3.80001 12.0267 2.66667C11.4933 2.15334 11.0333 1.94001 10.62 1.94001Z",
    fill: "url(#paint1_linear_2496_36289)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.56 7.3C11.5466 7.3 11.5266 7.3 11.5133 7.3C9.4333 7.09333 7.75996 5.51333 7.43996 3.44666C7.39996 3.17333 7.58663 2.92 7.85996 2.87333C8.1333 2.83333 8.38663 3.02 8.4333 3.29333C8.68663 4.90666 9.9933 6.14666 11.62 6.30666C11.8933 6.33333 12.0933 6.58 12.0666 6.85333C12.0333 7.10666 11.8133 7.3 11.56 7.3Z",
    fill: "url(#paint2_linear_2496_36289)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.56 7.3C11.5466 7.3 11.5266 7.3 11.5133 7.3C9.4333 7.09333 7.75996 5.51333 7.43996 3.44666C7.39996 3.17333 7.58663 2.92 7.85996 2.87333C8.1333 2.83333 8.38663 3.02 8.4333 3.29333C8.68663 4.90666 9.9933 6.14666 11.62 6.30666C11.8933 6.33333 12.0933 6.58 12.0666 6.85333C12.0333 7.10666 11.8133 7.3 11.56 7.3Z",
    fill: "url(#paint3_linear_2496_36289)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15.1667H2C1.72667 15.1667 1.5 14.94 1.5 14.6667C1.5 14.3933 1.72667 14.1667 2 14.1667H14C14.2733 14.1667 14.5 14.3933 14.5 14.6667C14.5 14.94 14.2733 15.1667 14 15.1667Z",
    fill: "#455CC7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2496_36289",
    x1: 2.24726,
    y1: 0.950821,
    x2: 2.24726,
    y2: 12.8494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3758CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3758CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2496_36289",
    x1: 8.00191,
    y1: 0.950821,
    x2: 8.00191,
    y2: 13.0133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3758CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2496_36289",
    x1: 7.46607,
    y1: 2.86794,
    x2: 7.46607,
    y2: 7.23975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3758CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3758CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2496_36289",
    x1: 9.75179,
    y1: 2.86794,
    x2: 9.75179,
    y2: 7.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3758CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEditmeta, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/editmeta.11fa3fc0.svg";
export { ForwardRef as ReactComponent };